<div class="row">
  <div class="col-md-12">
    <div class="side-summary my-3">
      <div class="row">
        <div class="col-md-12">
          <div class="summary-header top-radius">
            <div class="row">
              <div class="col-12">
                <ng-content select="uni-summary-header"></ng-content>
              </div>
            </div>
          </div>
          <div class="section-container">
            <div class="12">
              <ng-content select="uni-summary-group"></ng-content>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
